import { render, staticRenderFns } from "./VyungLTC.vue?vue&type=template&id=dc62961a&"
import script from "./VyungLTC.vue?vue&type=script&lang=js&"
export * from "./VyungLTC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports